import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { getEpochModels } from "../services/epochModelService";
import { fetchInspModels, parseInfo } from "../services/inspModelCache";

const inflight = new Map<number, Promise<[any, any]>>();
const fetchRoundSources = (projectId: number) => {
  let p = inflight.get(projectId);
  if (!p) {
    p = Promise.all([getEpochModels({ project_id: projectId }), fetchInspModels()]).finally(() =>
      inflight.delete(projectId),
    );
    inflight.set(projectId, p);
  }
  return p;
};

export const modelThreshold = (info: any): number | null => {
  const th = Number(info?.threshold ?? info?.performance?.threshold);
  return Number.isFinite(th) ? th : null;
};

export const useParsedModels = (inspModelList: any[]) => {
  const { id } = useParams();
  // trainHistory_id -> 회차. 임시(epoch-model) + 검사모델 전체 기준으로 순번을 매겨야
  // 목록이 달라도(비교 모달 / select) 같은 회차로 표시되고, temp -> inspModel 이동 후에도 유지됨
  const [roundMap, setRoundMap] = useState<Map<number, number>>(new Map());

  useEffect(() => {
    if (!id || inspModelList.length === 0) return;
    fetchRoundSources(Number(id))
      .then(([epochRes, inspRes]) => {
        const all = [
          ...epochRes.data.contents,
          ...inspRes.filter((m: any) => parseInfo(m.info).project_id === Number(id)),
        ];
        const ids = Array.from(new Set(all.map((m: any) => parseInfo(m.info).trainHistory_id).filter(Boolean))).sort(
          (a: any, b: any) => a - b,
        );
        setRoundMap(new Map(ids.map((hid, i) => [hid, i + 1])));
      })
      .catch(console.error);
  }, [id, inspModelList]);

  return useMemo(() => {
    return inspModelList
      .map((item) => {
        try {
          const parsed = JSON.parse(item.info!!);

          return {
            ...item,
            trainHistory_id: parsed.trainHistory_id || null,
            round: roundMap.get(parsed.trainHistory_id) ?? null,
            validHistory_id: parsed.validHistory_id || null,
            epoch: parsed.epoch,
            overkillPercent: parsed.performance ? `${(parsed.performance.overkill * 100).toFixed(2)}%` : "-",
            threshold: parsed.performance?.threshold ?? null,
            parentModel: parsed.parentModel || null,
          };
        } catch {
          return null;
        }
      })
      .filter(Boolean);
  }, [inspModelList, roundMap]);
};
